/**
 * Contact form helpers ("Redakcja"): the live character counter under the
 * message ([data-count-for]) and the chosen file's name in the drop zone
 * ([data-file-name]).
 */
export function initContactForm(scope = document) {
  scope.querySelectorAll('[data-count-for]').forEach((out) => {
    const field = document.getElementById(out.dataset.countFor);
    if (!field) return;
    const max = Number(field.getAttribute('maxlength')) || 0;
    const update = () => { out.textContent = `${field.value.length}/${max}`; };
    field.addEventListener('input', update);
    update();
  });

  scope.querySelectorAll('[data-file-name]').forEach((out) => {
    const input = document.getElementById(out.dataset.fileName);
    if (!input) return;
    const original = out.textContent;
    input.addEventListener('change', () => { out.textContent = input.files?.[0]?.name || original; });
  });
}
